"use strict";

exports.__esModule = true;
exports.win = exports.hasWin = exports.doc = void 0;
var _reshowConstant = require("reshow-constant");
//@ts-check

var defaultObj = {
  __null: true
};

/**
 * @param {object|undefined} w
 * @param {any} def
 * @returns {document}
 */
var doc = exports.doc = function doc(w, def) {
  if (w === void 0) {
    w = _reshowConstant.T_UNDEFINED;
  }
  if (def === void 0) {
    def = defaultObj;
  }
  var oDoc = (w || win()).document;
  return _reshowConstant.UNDEFINED !== typeof oDoc ? oDoc : def;
};

/**
 * @param {string} key
 * @returns {boolean}
 */
var hasWin = exports.hasWin = function hasWin(key) {
  if (key === void 0) {
    key = "__null";
  }
  return !win()[key];
};

/**
 * @param {any} def
 * @returns {window}
 */
var win = exports.win = function win(def) {
  if (def === void 0) {
    def = defaultObj;
  }
  return (
    /**
     * !!Important!! do not use reshow-constant here
     * Bable will transpile it to double undefined
     */
    "undefined" !== typeof window ? window : def
  );
};